import { all } from "redux-saga/effects";
import { combineReducers } from "redux";

import * as auth from "../app/modules/Auth/_redux/authRedux";
import * as alert from "../redux/alertSnackBarRedux";
import * as userProfile from "../redux/userProfileOverviewRedux";
import * as confirmModal from "../redux/confirmModalRedux"; 
import * as hubConnection from "../redux/hubConnectionRedux"
import * as clientProfile from "../redux/ClientProfileOverViewRedux";
import { customersSlice } from "../app/modules/ECommerce/_redux/customers/customersSlice";
import { productsSlice } from "../app/modules/ECommerce/_redux/products/productsSlice";
import { remarksSlice } from "../app/modules/ECommerce/_redux/remarks/remarksSlice";
import { specificationsSlice } from "../app/modules/ECommerce/_redux/specifications/specificationsSlice";

export const rootReducer = combineReducers({
  auth: auth.reducer,
  alert: alert.reducer,
  hub: hubConnection.reducer,
  clientProfile: clientProfile.reducer,
  customers: customersSlice.reducer,
  products: productsSlice.reducer,
  remarks: remarksSlice.reducer,
  specifications: specificationsSlice.reducer,
  userProfile: userProfile.reducer,
  confirmModal: confirmModal.reducer
});

export function* rootSaga() {
  yield all([auth.saga()]);
  // yield all([alert.saga()]);
}
